import { iconByProduct } from 'features/subscriptions/utils';
import { forIn, get, pick } from 'lodash';
import { ResourceByProductType } from './types/types';

export const validResources = {
  xmcloud: iconByProduct.xmcloud,
  personalize: iconByProduct.personalize,
  cdp: iconByProduct.cdp,
  search: iconByProduct.search,
  edge: iconByProduct.xmcloud,
};

export function pickObjectsDifferences<T>(obj: T, comparator: T): any {
  const keysToPick: string[] = [];
  forIn(obj, (value, key) => {
    if (value !== get(comparator, key)) {
      keysToPick.push(key);
    }
  });

  return keysToPick.length ? pick(obj, keysToPick) : null;
}

const CHARSET =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

export function encode(int: number) {
  if (int === 0) {
    return CHARSET[0];
  }

  let res = '';
  while (int > 0) {
    res = CHARSET[int % 62] + res;
    int = Math.floor(int / 62);
  }
  return res;
}

export function guidToBase62(guid: string): string {
  const hex = guid.replace(/-/g, '');
  const decimal = BigInt('0x' + hex);
  return encode(Number(decimal));
}

export const generateContextId = (guid: string) => guidToBase62(guid);

export const groupResourcesByType = (resources: ResourceByProductType[]) =>
  resources.reduce((acc, obj) => {
    const key = obj.productCode as keyof typeof acc;
    if (!acc[key]) {
      //@ts-ignore
      acc[key] = [];
    }
    //@ts-ignore
    acc[key].push(obj);
    return acc;
  }, {});

export const addShowHeaderFlag = (resources?: ResourceByProductType[]) => {
  const projectNames = new Set();
  return (
    resources?.map((item) => {
      // for non live-preview tenants
      if (!item.environment) return item;

      const projectName = item.tenantName;
      if (!projectNames.has(projectName)) {
        projectNames.add(projectName);
        return { ...item, showHeader: true };
      } else {
        return { ...item, showHeader: false };
      }
    }) ?? []
  );
};

export const transformResources = (resources: ResourceByProductType[]) => {
  const groupedResourcesByType = groupResourcesByType(resources);
  const transformedXMCTenants = addShowHeaderFlag(
    groupedResourcesByType['XMCloud' as keyof typeof groupedResourcesByType],
  );

  if (transformedXMCTenants.length)
    //@ts-ignore
    groupedResourcesByType['XMCloud' as keyof typeof groupedResourcesByType] =
      transformedXMCTenants;

  return groupedResourcesByType;
};

export const getResourcePayload = ({
  tenantId,
  productCode,
  environment,
}: ResourceByProductType) => ({
  tenantId,
  productCode,
  environment,
});

export const validateProductSelection = (
  productCode: string,
  selectedProducts: { productCode: string; tenants: ResourceByProductType[] }[],
): boolean => {
  const isCDPSelected = selectedProducts.some(
    (product) => product.productCode === validResources.cdp.name,
  );
  const isPersonalizeSelected = selectedProducts.some(
    (product) => product.productCode === validResources.personalize.name,
  );

  return (
    (productCode === validResources.cdp.name && isPersonalizeSelected) ||
    (productCode === validResources.personalize.name && isCDPSelected)
  );
};
